import ProgressStepperHeader from "@common/components/stepper/ProgressStepperHeader"
import React, { useContext } from "react"
import { Platform, View } from "react-native"
import CircularProgress from "react-native-circular-progress-indicator/src/circularProgress/index"
import { ActivityIndicator } from "react-native-paper"
import ChampionBubble from "../../../student/champions/ChampionBubble"
import { theme } from "../../theme/theme"
import { DimensionsContext, IS_WEB } from "../../utils/mobileUtils"
import FilledButtonM from "../button/FilledButtonM"
import TextM from "../text/TextM"

const ProgressStepper = (props) => {
    const dimensions = useContext(DimensionsContext)

    // ** Component props
    const {
        navigation,
        steps,
        exitHandler,
        champion,
        championLabels,
        hideProgressBar = false,
        submitButtonText = "Terminer",
        submitButtonColor = theme.colors.success,
        currentStep,
        setCurrentStep,
        onNextButtonPress,
        submitted,
        headerRightComponent,
        submittedMessage,
        previousRouteName = "menu",
        exitWarning,
        noPrevious,
        noGoBack,
        noNavigation = false,
        circularProgress,
        circularProgressValue,
        exitWarningMessage,
        track = false,
        champions,
        flex = 1,
        hideBottomButton = false, // New prop to hide the bottom button
    } = props

    const isFirstStep = currentStep === 1
    const isLastStep = currentStep === steps?.length

    const goToPreviousStep = () => {
        if (!isFirstStep) setCurrentStep((cs) => cs - 1)
    }

    return (
        <View
            style={{
                flex: 1,
                backgroundColor: theme.colors.whiteAlmost,
                alignItems: "center",
                justifyContent: "flex-start",
            }}
        >
            <ProgressStepperHeader
                navigation={navigation}
                noNavigation={noNavigation}
                track={track}
                currentStep={currentStep}
                exitWarning={exitWarning}
                exitHandler={exitHandler}
                noPrevious={noPrevious}
                noGoBack={noGoBack}
                previousRouteName={previousRouteName}
                countSteps={steps?.length}
                hideProgressBar={hideProgressBar}
                headerRightComponent={headerRightComponent}
                goToPreviousStep={goToPreviousStep}
                exitWarningMessage={exitWarningMessage}
                submitted={submitted}
            />

            {!submitted && (champion || champions?.some((x) => x !== null)) && (
                <ChampionBubble
                    name={champion?.name ?? champions[currentStep - 1]?.name}
                    variant={
                        champion?.variant ?? champions[currentStep - 1]?.variant
                    }
                    championPosition="left"
                    texts={[championLabels[currentStep - 1]]}
                    style={{ marginTop: -20 }}
                />
            )}

            {!submitted ? (
                steps?.[currentStep - 1]?.content
            ) : (
                <View
                    style={{
                        flex: 1,
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    {circularProgress ? (
                        IS_WEB ? (
                            <TextM
                                color={theme.colors.success}
                                fontWeight={"Bold"}
                            >
                                {circularProgressValue + "%"}
                            </TextM>
                        ) : (
                            <CircularProgress
                                title={circularProgressValue + "%"}
                                value={circularProgressValue}
                                radius={40}
                                activeStrokeColor={theme.colors.success}
                                inActiveStrokeColor={theme.colors.success}
                                activeStrokeWidth={10}
                                inActiveStrokeWidth={10}
                                inActiveStrokeOpacity={0.1}
                                textColor={theme.colors.success}
                                titleStyle={{ fontFamily: "Montserrat-Bold" }}
                                titleFontSize={16}
                                showProgressValue={false}
                            />
                        )
                    ) : (
                        <ActivityIndicator
                            animating={true}
                            style={{
                                alignSelf: "center",
                                justifySelf: "center",
                                marginTop: IS_WEB ? 50 : -50,
                                marginBottom: 10,
                            }}
                            size="large"
                            color={theme.colors.primary}
                        />
                    )}
                    <TextM
                        fontWeight="Bold"
                        color={theme.colors.grey}
                        style={{
                            marginTop: 10,
                        }}
                        fontSize={22}
                    >
                        Chargement en cours...
                    </TextM>
                    {!!submittedMessage && submittedMessage !== "" && (
                        <TextM
                            fontWeight="Regular"
                            color={theme.colors.light}
                            style={{
                                marginTop: 5,
                            }}
                            fontSize={16}
                        >
                            {submittedMessage}
                        </TextM>
                    )}
                </View>
            )}
            {!submitted &&
                !hideBottomButton &&
                !steps?.[currentStep - 1]?.hideNextButton &&
                !steps?.[currentStep - 1]?.hideSubmitButton && (
                    <View
                        style={{
                            backgroundColor: theme.colors.whiteTransparentMore,
                            paddingTop: Platform.OS !== "web" ? 10 : null,
                            paddingBottom: Platform.OS === "ios" ? 20 : 5,
                            position: "absolute",
                            bottom: 0,
                            width:
                                flex === 1 ? "100%" : dimensions.width * flex,
                            alignItems: "center",
                            alignSelf: "center",
                        }}
                    >
                        <FilledButtonM
                            color={
                                isLastStep
                                    ? submitButtonColor
                                    : theme.colors.primary
                            }
                            loading={
                                submitted ||
                                !!steps?.[currentStep - 1]?.nextButtonLoading
                            }
                            onPress={
                                IS_WEB
                                    ? () => {
                                          window.scrollTo(0, 0)
                                          onNextButtonPress()
                                      }
                                    : onNextButtonPress
                            }
                            style={{
                                width:
                                    dimensions.width > 800
                                        ? (dimensions.width * flex) / 1.2
                                        : dimensions.width * flex - 20,
                                alignSelf: "center",
                                marginTop: 15,
                                marginBottom: 15,
                            }}
                            label={isLastStep ? submitButtonText : "Suivant"}
                        />
                    </View>
                )}
        </View>
    )
}

export default ProgressStepper
